/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Scope_Output5Inputs */

const en_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual-process map`)
};

const ar_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة العمليات اليدوية`)
};

const bn_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ম্যানুয়াল-প্রসেস ম্যাপ`)
};

const de_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Prozesskarte`)
};

const es_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de proceso manual`)
};

const fr_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte des processus manuels`)
};

const pt_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de processo manual`)
};

const zh_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动流程图`)
};

const tr_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuel işlem haritası`)
};

const ru_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта ручного процесса`)
};

const pl_svc_automation_scope_output5 = /** @type {(inputs: Svc_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa procesu ręcznego`)
};

/**
* | output |
* | --- |
* | "Manual-process map" |
*
* @param {Svc_Automation_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_scope_output5 = /** @type {((inputs?: Svc_Automation_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_scope_output5(inputs)
	if (locale === "bn") return bn_svc_automation_scope_output5(inputs)
	if (locale === "de") return de_svc_automation_scope_output5(inputs)
	if (locale === "es") return es_svc_automation_scope_output5(inputs)
	if (locale === "fr") return fr_svc_automation_scope_output5(inputs)
	if (locale === "pt") return pt_svc_automation_scope_output5(inputs)
	if (locale === "zh") return zh_svc_automation_scope_output5(inputs)
	if (locale === "tr") return tr_svc_automation_scope_output5(inputs)
	if (locale === "ru") return ru_svc_automation_scope_output5(inputs)
	if (locale === "pl") return pl_svc_automation_scope_output5(inputs)
	return en_svc_automation_scope_output5(inputs)
});
export { svc_automation_scope_output5 as "svc_automation_SCOPE_output" }